import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import addFraudProtection from 'components/utils/addFraudProtection'
import { paymentMethodsDispatchers as mergeProps } from 'reduxModules/users/dispatchers'
import { paymentMethodSelector as stateSelector } from 'reduxModules/forms/paymentMethod/selectors'

import PaymentMethodForm from '../../generic/PaymentMethodForm'
import CardFieldsAlert from '../../generic/PaymentMethodForm/CardFieldsAlert'
import PaymentMethodList from './PaymentMethodList'
import { CaptchaNotice } from '../../generic/CaptchaNotice'
import CaptchaStandalone from '../../CaptchaStandalone/_lazy'
import getCardIcon from '../../utils/getCardIcon'
import './styles.css'

class PaymentMethods extends Component {
  constructor(props) {
    super(props)
    this.saveCreditCard = this.saveCreditCard.bind(this)
  }

  componentDidMount() {
    this.props.getBraintreeClientToken()
    this.props.loadPaymentMethods()
  }

  saveCreditCard() {
    const {
      clientToken,
      savePaymentMethod,
      showFraudProtectionError,
      tokenizer,
      recaptcha
    } = this.props

    addFraudProtection(
      savePaymentMethod,
      [tokenizer, recaptcha],
      clientToken,
      showFraudProtectionError
    )
  }

  render() {
    const {
      paymentMethodsCount,
      showForm,
      showNewPaymentMethodForm,
      hideNewPaymentMethodForm,
      clientToken
    } = this.props

    return (
      <div id="PaymentMethods" className="account-section">
        <h3 className="account-section__title">payment methods</h3>
        {paymentMethodsCount !== 0 && (
          <div className="payment-methods-content">
            <PaymentMethodList />
          </div>
        )}
        {paymentMethodsCount === 0 && (
          <p className="payment-methods-empty-content">You don&apos;t have any credit cards.</p>
        )}
        {!showForm && (
          <div className="add-payment-method">
            <div className="accepted-cards">
              <img src={getCardIcon('visa')} alt="visa" />
              <img src={getCardIcon('master-card')} alt="mastercard" />
              <img src={getCardIcon('american-express')} alt="amex" />
            </div>
            <button type="button" className="add-payment-button" onClick={() => showNewPaymentMethodForm()}>
              <i className="icon-plus" />
              add credit card
            </button>
          </div>
        )}
        {showForm && (
          <div className="create-payment-methods">
            <h3 className="account-section__title">New Credit Card</h3>
            <PaymentMethodForm authorization={clientToken}>
              <div className="captcha-container">
                <CaptchaStandalone />
              </div>
              <CardFieldsAlert />
              <div className="buttons-subcontainer">
                {paymentMethodsCount > 0 && (
                  <button
                    type="button"
                    className="cancel-payment-btn"
                    onClick={() => hideNewPaymentMethodForm()}
                  >
                    cancel
                  </button>
                )}
                <button
                  type="submit"
                  className="submit-btn"
                  onClick={() => this.saveCreditCard()}
                >
                  Save Credit Card
                </button>
              </div>
              <CaptchaNotice />
            </PaymentMethodForm>
          </div>
        )}
      </div>
    )
  }
}

PaymentMethods.propTypes = {
  getBraintreeClientToken: PropTypes.func.isRequired,
  showNewPaymentMethodForm: PropTypes.func.isRequired,
  hideNewPaymentMethodForm: PropTypes.func,
  loadPaymentMethods: PropTypes.func,
  showForm: PropTypes.bool.isRequired,
  clientToken: PropTypes.string.isRequired,
  paymentMethodsCount: PropTypes.number,
  savePaymentMethod: PropTypes.func,
  showFraudProtectionError: PropTypes.func,
  tokenizer: PropTypes.any,
  recaptcha: PropTypes.any
}

PaymentMethods.defaultProps = {
  hideNewPaymentMethodForm: () => {},
  loadPaymentMethods: () => {},
  paymentMethodsCount: 0,
  savePaymentMethod: () => {},
  showFraudProtectionError: () => {},
  tokenizer: null,
  recaptcha: null
}

export default connect(stateSelector, null, mergeProps)(PaymentMethods)
